import { Injector, runInInjectionContext, signal } from '@angular/core';
import { INFLUENCER } from '@core/models/ApiFields/ig-field-values.enums';
import { Influencer } from '@core/models/ApiFields/ig-field-values.types';
import { SocialComment } from '@features/inbox/inb-posts/comment.types';
import { PostCommentsHttpBuilder } from '@features/social-analysis/social-listening/services/post-comments.http';
import { BaseState } from './state.store';

export class CommentsState extends BaseState<SocialComment> {
    #http!: PostCommentsHttpBuilder;

    selInfluencerTypes = signal<Influencer[]>(Object.values(INFLUENCER));
    isLoadingReplies = signal<string[]>([]);
    isPersonalOn = signal(false);

    constructor(injector: Injector) {
        super();
        runInInjectionContext(injector, () => (this.#http = new PostCommentsHttpBuilder()));
    }

    reqData({ postId, parentId, userAcc }: { postId: string; parentId?: string; userAcc: string }) {
        const filters = {
            postId: postId,
            parentId: parentId,
            influencer: this.selInfluencerTypes(),
            userAcc: this.isPersonalOn() ? userAcc : null,
        };

        this.#http.reqComments(this, filters);
    }
}
